
import http from '@utils/http';

export function myContract() {
  return http.get('/api/pact/h5/weilai/contract/myContract');
}

export function sendEContract(params) {
  return http.post('/api/pact/h5/weilai/contract/sendEContract', params);
}

export function eContractPreview(params) {
  return http.post(`/api/pact/h5/weilai/contract/eContractPreview?recordId=${params.recordId}`, params);
}

